import requestAction from '../../utils/requestAction'

export const fetchLinkedVendors = (params: string) =>
  requestAction('LINKED_VENDORS_LIST', params)(`linkedVendors`, 'GET')
